import PropertyField from 'src/components/PropertyField/PropertyField';

import type { Cell, Id } from '.';

type CellProps = {
  item: Cell;
  rowIndex: number;
  handleChangeValue: (id: Id, rowIndex: number, value: string) => void;
  handleSelectMedia?: (
    properties: ImageProperties,
    handleSelectValue?: (value: string) => void
  ) => void;
};

const Cell = ({ item, rowIndex, handleChangeValue, handleSelectMedia }: CellProps) => (
  <PropertyField
    field={item}
    onChange={(value) => handleChangeValue(item.id, rowIndex, String(value))}
    onSelectMedia={handleSelectMedia}
  />
);

export default Cell;
